"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _BrandConfigContext = require("@insided/shared/services/BrandConfigContext");

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var config = _zod.z.object({
  courses: _zod.z.array(_zod.z.object({
    id: _zod.z.string(),
    type: _zod.z.string(),
    attributes: _zod.z.object({
      name: _zod.z.string()
    }),
    links: _zod.z.object({
      resource: _zod.z.string()
    })
  }))
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;
var cssAnchorName = 'widget-customer-education';
exports.cssAnchorName = cssAnchorName;

var CE = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CE, _Component);

  var _super = _createSuper(CE);

  function CE() {
    (0, _classCallCheck2.default)(this, CE);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CE, [{
    key: "render",
    value: function render() {
      var _this = this;

      return (0, _preact.h)(_BrandConfigContext.BrandConfigContext.Consumer, null, function (_ref) {
        var config = _ref.config;
        return _this.renderCEWidget(config);
      });
    }
  }, {
    key: "renderCEWidget",
    value: function renderCEWidget(brandingConfig) {
      var _this$props = this.props,
          config = _this$props.config,
          widgetName = _this$props.widgetName,
          templateId = _this$props.templateId;
      return (0, _preact.h)(_widgetContainer.default, {
        config: config,
        widgetName: widgetName
      }, (0, _preact.h)("div", {
        "data-bounded-context": "Education",
        "data-entity": widgetName
      }, (0, _preact.h)("customer-education-element", {
        "data-template-id": templateId,
        "data-config": JSON.stringify(brandingConfig)
      })));
    }
  }]);
  return CE;
}(_preact.Component);

var _default = CE;
exports.default = _default;